// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './constants';
import * as actionsInterfaces from './types';

export const getDealerAPI = (page?: number, limit?: number, query?: string, group?:string | null, id?:string, loading?:boolean): actionsInterfaces.ActionGetDealerAPI => ({
    type: ACTIONS.GET_DEALER_API_REQUEST,
    page,
    limit,
    query,
    group,
    id,
    loading
});

export const getDealerAPISuccess = (dealers: actionsInterfaces.Dealer[], page?: number, loading?:boolean): actionsInterfaces.ActionGetDealerApiSuccess => ({
    type: ACTIONS.GET_DEALER_API_SUCCESS,
    dealers,
    page,
    loading
});

export const getDealerAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_DEALER_API_ERROR,
    error
});

export const dealersLoadMore = () => ({
    type: ACTIONS.DEALERS_LOAD_MORE
})

export const editDealerSearchQuery = (query: string): actionsInterfaces.ActionEditDealerSearchQuery => ({
    type: ACTIONS.EDIT_DEALER_SEARCH_QUERY,
    query
})

export const editSelectedDealer = (dealer?: actionsInterfaces.Dealer): actionsInterfaces.ActionEditSelectedDealer => ({
    type: ACTIONS.EDIT_SELECTED_DEALER,
    dealer
})

export const getDealerByIdAPI = (dealerId: string): actionsInterfaces.ActionGetDealerById => {
    return {
        type: ACTIONS.GET_DEALER_BY_ID_API_REQUEST,
        dealerId
    }
}

export const getDealerByIdAPISuccess = (dealer: actionsInterfaces.Dealer): actionsInterfaces.ActionGetDealerByIdSuccess => {
    return {
        type: ACTIONS.GET_DEALER_BY_ID_API_SUCCESS,
        dealer
    }
}

export const getDealerByIdAPIError = (error: any): actionsInterfaces.ActionGetDealerByIdError => {
    return {
        type: ACTIONS.GET_DEALER_BY_ID_API_ERROR,
        error
    }
}

export const getDealerCollections = (collectionsRequest: actionsInterfaces.IGetCollections, callback: (result: any, erro: any) => void): actionsInterfaces.IGetCollectionsAction => {
    return {
        type: ACTIONS.GET_DEALER_COLLECTIONS,
        collectionsRequest,
        callback
    }
}

export const getDealerAssets = (assetsRequest: actionsInterfaces.IGetAssets, callback: (result: any, erro: any) => void): actionsInterfaces.IGetAssetsAction => {
    return {
        type: ACTIONS.GET_DEALER_ASSETS,
        assetsRequest,
        callback
    }
}

export const getDealerAssetsNames = (assetsNamesRequest: actionsInterfaces.IGetAssetsNames, callback: (result: any, erro: any) => void): actionsInterfaces.IGetAssetsNamesAction => {
    return {
        type: ACTIONS.GET_DEALER_ASSETS_NAMES,
        assetsNamesRequest,
        callback
    }
}

export const setDealerCollections = (collectionsResponse: actionsInterfaces.IDealerCollection[]): actionsInterfaces.ISetCollectionsAction => {
    return {
        type: ACTIONS.SET_DEALER_COLLECTIONS,
        collectionsResponse,
    }
}

export const setDealerAssets = (assetsResponse: actionsInterfaces.IDealerAssetObject): actionsInterfaces.ISetAssetsAction => {
    return {
        type: ACTIONS.SET_DEALER_ASSETS,
        assetsResponse,
    }
}

export const setDealerAssetsNames = (assetsNameResponse: actionsInterfaces.IDealerAssetNamesObject):actionsInterfaces.ISetAssetsNamesAction => {
    return {
        type: ACTIONS.SET_DEALER_ASSETS_NAMES,
        response: assetsNameResponse
    }
}

export const getExtDealerByIdAPI = (dealerId: string, callback: (result: any, erro: any) => void): actionsInterfaces.IActionGetExtDealerById => {
    return {
        type: ACTIONS.GET_EXTDEALER_BY_ID_API_REQUEST,
        dealerId,
        callback
    }
}